import { useNavigate } from 'react-router-dom'
import { Button } from '~/shadcn/ui/button/button'
import { AddIcon } from '~/@mid_ui/icons/AddIcon'
import { WithdrawIcon } from '~/@mid_ui/icons/WithdrawIcon'
import { useLocalNotifications } from '~/@mid_ui/local-notifications/useLocalNotifications'
import { useUser } from '~/@biz_account/useUser/useUser'

export function AccountFundsButtons() {
  const { setNotification } = useLocalNotifications()
  const navigate = useNavigate()
  const { user } = useUser()

  const isFundsOperationsEnabled = !!user?.isWithdrawAndAddFundsEnabled

  function handleAddWithdrawFUndsButtonClicked() {
    if (!user?.profile?.bankAccounts?.length) {
      setNotification(
        'error',
        'Pre výber finančných prostriedkov nastavte Váš bankový účet.'
      )
      navigate('/settings/bank-accounts')
      return
    }
    navigate('/account/withdraw-funds')
  }

  return (
    <div className="flex flex-col-reverse xl:flex-row w-full md:w-auto gap-5">
      <Button
        variant="outline"
        size="adaptive"
        disabled={!isFundsOperationsEnabled}
        onClick={handleAddWithdrawFUndsButtonClicked}>
        <WithdrawIcon className="w-5! h-5!" />
        Vybrať fin. prostriedky
      </Button>
      <Button
        variant="accent"
        size="adaptive"
        disabled={!isFundsOperationsEnabled}
        onClick={() => navigate('/account/add-funds')}>
        <AddIcon className="w-5! h-5!" />
        Pridať fin. prostriedky
      </Button>
    </div>
  )
}
